// extracted by mini-css-extract-plugin
module.exports = {"search-wrapper":"SidePanel-module__search-wrapper__4PraI","domain-carousel":"SidePanel-module__domain-carousel__3B91F"};